/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_MinInputs */

const en_editor_prep_min = /** @type {(inputs: Editor_Prep_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep (min)`)
};

const de_editor_prep_min = /** @type {(inputs: Editor_Prep_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereitung (Min.)`)
};

/**
* | output |
* | --- |
* | "Prep (min)" |
*
* @param {Editor_Prep_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_min = /** @type {((inputs?: Editor_Prep_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_min(inputs)
	return en_editor_prep_min(inputs)
});